/* eslint-disable no-console */

/* eslint-disable @typescript-eslint/no-explicit-any */
import { MiPlatformSignalREventNames } from "@miplatform/types";
import { bufferTime, filter, map, pipe } from "rxjs";
import { SignalrHub } from "./SignalrHub";

const BATCH_LIMIT = 5;
const EMISSION_WAIT_TIME = 500;

const mapEvent = (filterOut: (eventData: any) => boolean) =>
  pipe(
    map((event: string) => {
      let parsed = null;
      try {
        parsed = JSON.parse(event || "{}")?.data;
      } catch (e) {
        console.error(e);
      }
      return parsed;
    }),
    filter((event) => filterOut(event)),
    bufferTime(EMISSION_WAIT_TIME, null, BATCH_LIMIT),
    filter((events) => !!events.filter(Boolean).length)
  );

export const subscribeToUserUpdate = (
  hub: SignalrHub,
  callback: (payload: any) => void,
  filterOut: (data: any) => boolean = () => true
) =>
  hub
    .on(MiPlatformSignalREventNames.UserUpdated)
    .pipe(mapEvent(filterOut) as any)
    .subscribe(callback, (err) => {
      console.error(err);
    });

export const subscribeToAttemptUpdate = (
  hub: SignalrHub,
  callback: (payload: any) => void,
  filterOut: (data: any) => boolean = () => true
) =>
  hub
    .on(MiPlatformSignalREventNames.AttemptUpdated)
    .pipe(mapEvent(filterOut) as any)
    .subscribe(callback, (err) => {
      console.error(err);
    });

export const subscribeToAutoAssignStatusUpdate = (
  hub: SignalrHub,
  callback: (payload: any) => void,
  filterOut: (data: any) => boolean = () => true
) =>
  hub
    .on(MiPlatformSignalREventNames.AutoAssignStatusUpdated)
    .pipe(mapEvent(filterOut) as any)
    .subscribe(callback, (err) => {
      console.error(err);
    });

export const subscribeToHubStateChange = (
  hub: SignalrHub,
  callback: (payload: any) => void
) => {
  return hub.state$.subscribe(callback, (err) => {
    console.error(err);
  });
};

export const subscribeToGlobalSignalrMessage = (
  hub: SignalrHub,
  callback: (payload: any) => void,
  filterOut: (data: any) => boolean = () => true
) =>
  hub
    .on(MiPlatformSignalREventNames.GlobalMessageReceived)
    .pipe(mapEvent(filterOut) as any)
    .subscribe(callback, (err) => {
      console.error(err);
    });
